import { createApp } from 'vue'; // Import createApp and App type
import store from './store/store'; // Assuming Vuex 4+ store
import Explore from "./Explore.vue";

declare global {
  interface Window {
    typesenseUrl: string;
    typesenseSearchApiKey: string;
    country_id: number | null;
    region_id: number | null;
  }
}

const mountElement = document.querySelector('#explore_v2');

if (mountElement) {
  const newApp = createApp(Explore);
  newApp.use(store);
  newApp.mount('#explore_v2');
} else {
  console.warn('Mount element #explore_v2 not found.');
}
